<mat-form-field appearance="fill">
    <mat-label>{{text('orderSelection.title')}}</mat-label>
    <mat-select [(value)]="defaultOrder" (valueChange)="onValueChanged($event)">
        <mat-option *ngFor="let item of items" [value]="item.key">
            {{item.value}}
        </mat-option>
    </mat-select>
</mat-form-field>
